export const apiConstants = {
  url: "/api/itemcategory"
};
